<div *ngIf="open" (click)="closeDrawer()" class="fixed inset-0 z-[60] bg-slate-900/45"></div>

<aside
  class="fixed top-0 right-0 h-full w-[420px] max-w-[90vw] z-[70] bg-white border dark:border-slate-700 dark:bg-gray-900 flex flex-col shadow-[-10px_0_30px_rgba(15,23,42,0.15)] transition-all duration-300 ease-in-out"
  [class.right-0]="open" [class.-right-[420px]]="!open">
  <!-- Header -->
  <div class="flex items-center justify-between p-6 border-b border-slate-200 dark:border-slate-700">
    <div>
      <p class="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400">
        {{ title }}
      </p>
      <p class="text-lg font-semibold text-slate-900 dark:text-slate-100">
        {{ entityId ? 'Edita la información del' : 'Completa la información para crear un nuevo' }}
        {{ endpoint === 'clients' ? 'cliente' : 'profesional' }}
      </p>
    </div>
    <button type="button"
      class="border-none bg-transparent text-2xl leading-none cursor-pointer text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200"
      (click)="closeDrawer()">
      ×
    </button>
  </div>

  <!-- Body -->
  <div class="flex-1 overflow-y-auto p-5 flex flex-col gap-4 relative">
    <section [class.opacity-50]="isLoading()" [class.pointer-events-none]="isLoading()">
      <app-people-add #peopleAdd [endpoint]="endpoint" [entityId]="entityId"></app-people-add>
    </section>
    <div *ngIf="isLoading()"
      class="absolute inset-0 flex flex-col items-center justify-center gap-2 text-slate-500 dark:text-slate-400 bg-white/75 dark:bg-gray-900/75 backdrop-blur-sm z-10">
      <span
        class="w-8 h-8 rounded-full border-[3px] border-slate-200 dark:border-slate-700 border-t-slate-900 dark:border-t-slate-100 animate-spin"></span>
      Procesando...
    </div>
  </div>

  <!-- Footer -->
  <div class="flex gap-3 p-5 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
    <button type="button"
      class="inline-flex items-center justify-center gap-2 border border-transparent rounded-xl px-4 py-2.5 font-semibold bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-slate-100 cursor-pointer transition-all flex-1 hover:bg-slate-300 dark:hover:bg-slate-600 disabled:opacity-60 disabled:cursor-not-allowed"
      (click)="closeDrawer()" [disabled]="isLoading()">
      Cancelar
    </button>
    <button type="button"
      class="inline-flex items-center justify-center gap-2 border border-transparent rounded-xl px-4 py-2.5 font-semibold bg-brand-500 dark:bg-brand-600 text-white cursor-pointer transition-all flex-1 hover:bg-brand-600 dark:hover:bg-brand-700 disabled:opacity-60 disabled:cursor-not-allowed"
      (click)="onCreate()" [disabled]="isLoading()">
      <span *ngIf="isLoading()"
        class="w-4 h-4 rounded-full border-2 border-white/20 border-t-white animate-spin"></span>
      {{ entityId ? 'Actualizar' : 'Crear' }}
    </button>
  </div>
</aside>
